import { render, staticRenderFns } from "./insurance_type.vue?vue&type=template&id=62128094&scoped=true"
import script from "./insurance_type.vue?vue&type=script&lang=js"
export * from "./insurance_type.vue?vue&type=script&lang=js"
import style0 from "./insurance_type.vue?vue&type=style&index=0&id=62128094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62128094",
  null
  
)

export default component.exports